import { Box, Chip, Typography } from '@mui/material';

import { useTranslations } from 'context/TranslationContext';

import {
  getApprovalModeChipStyle,
  getApprovalModeLabel
} from 'utils/helpers/approvalsHelpers';

import { baseHeader } from 'styles/components/Common';
import {
  matchedRuleCardStyle,
  matchedRuleChipsStyle,
  matchedRuleHeaderStyle,
  matchedRuleNameStyle,
  matchedRulesSectionStyle
} from 'styles/pages/ApprovalRuleSimulatorStyles';
import { chipExclusiveStyle, chipGrayStyle } from 'styles/pages/ApprovalsStyle';

import { MatchedRule } from '../../../../utils/interfaces/ApprovalSimulator';

export interface MatchedRulesSectionProps {
  rules: MatchedRule[];
}

export const MatchedRulesSection = ({ rules }: MatchedRulesSectionProps) => {
  const { translate } = useTranslations();

  if (rules.length === 0) {
    return null;
  }

  return (
    <Box sx={matchedRulesSectionStyle}>
      <Typography sx={baseHeader}>
        {translate('approvalSimulator.results.matchedRules', {
          count: rules.length.toString()
        })}
      </Typography>

      {rules.map((rule) => (
        <Box key={`matched-rule-${rule.id}`} sx={matchedRuleCardStyle}>
          <Box sx={matchedRuleHeaderStyle}>
            <Typography sx={matchedRuleNameStyle}>{rule.name}</Typography>

            <Box sx={matchedRuleChipsStyle}>
              {rule.approvalMode && (
                <Chip
                  size="small"
                  label={getApprovalModeLabel(rule.approvalMode, translate)}
                  sx={getApprovalModeChipStyle(rule.approvalMode.toString())}
                />
              )}
              {rule.isExclusive && !rule.isFallback && (
                <Chip
                  size="small"
                  label={translate('approvals.exclusive')}
                  sx={chipExclusiveStyle}
                />
              )}
              {rule.isFallback && (
                <Chip
                  size="small"
                  label={translate('approvalSimulator.results.fallback')}
                  sx={chipGrayStyle}
                />
              )}
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};
